import Iconmoon, { IconWrapper } from '@deprecated-ui/common/Iconmoon';
import Text from '@deprecated-ui/common/Text';
import { PopoverCustom as PopoverMobile } from '@deprecated-ui/header';
import color from '@deprecated-ui/_style/color';
import { useSelector } from 'react-redux';
import { useRouter } from 'next/router';

import generateNavBar from 'utils/navbar';
import { selectors } from 'lib/entities/profile';
import useTradingAccount from 'hooks/useTradingAccount';
import RealTradingMobile from '../RealTrading/Mobile';
import VirtualTradingMobile from '../VirtualTrading/Mobile';
import InitialTradingMobile from '../InitialTrading/Mobile';
import ExpandMenuOpen from './ExpandMenuOpen';
import { PopoverNavbarContainer, IconClose, Grid } from './styled';
import ReloadHandler from './ReloadHandler';
import IconStream from 'assets/customIcon/PopoverNavbarContainer/IconStream';
import IconProfile from 'assets/customIcon/PopoverNavbarContainer/IconProfile';
import IconWatchlist from 'assets/customIcon/PopoverNavbarContainer/IconWatchlist';
import IconChat from 'assets/customIcon/PopoverNavbarContainer/IconChat';
import IconChartbit from 'assets/customIcon/PopoverNavbarContainer/IconChartbit';
import IconOrderbook from 'assets/customIcon/PopoverNavbarContainer/IconOrderbook';
import IconEIpo from 'assets/customIcon/PopoverNavbarContainer/IconEIpo';
import IconAcademy from 'assets/customIcon/PopoverNavbarContainer/IconAcademy';
import IconScreener from 'assets/customIcon/PopoverNavbarContainer/IconScreener';
import IconValuation from 'assets/customIcon/PopoverNavbarContainer/IconValuation';
import IconFinancials from 'assets/customIcon/PopoverNavbarContainer/IconFinancials';
import IconFundachart from 'assets/customIcon/PopoverNavbarContainer/IconFundachart';
import IconSeasonality from 'assets/customIcon/PopoverNavbarContainer/IconSeasonality';
import IconSector from 'assets/customIcon/PopoverNavbarContainer/IconSector';
import IconCalender from 'assets/customIcon/PopoverNavbarContainer/IconCalender';
import IconEarnings from 'assets/customIcon/PopoverNavbarContainer/IconEarnings';
import IconGlossary from 'assets/customIcon/PopoverNavbarContainer/IconGlossary';
import IconEBook from 'assets/customIcon/PopoverNavbarContainer/IconEBook';

function componentTrigger(isButtonActive) {
  if (isButtonActive) {
    return (
      <IconClose size="60px">
        <Iconmoon size="25px" className="icon-compose_close" />
      </IconClose>
    );
  }
  return (
    <IconWrapper size="60px">
      <ExpandMenuOpen />
    </IconWrapper>
  );
}

export const Mobile = () => {
  const router = useRouter();
  const { data } = useSelector(selectors);
  const { isRealTrading, isVirtualTrading, tradingType } = useTradingAccount();

  const renderTradingPopup = () => {
    if (!tradingType) return <InitialTradingMobile />;
    if (isRealTrading) return <RealTradingMobile />;
    if (isVirtualTrading) return <VirtualTradingMobile />;
    return <div />;
  };

  const renderIcon = (logo) => {
    switch (logo) {
      case 'icon-menu3_home':
        return <IconStream />;
      case 'icon-menu3_profile':
        return <IconProfile />;
      case 'icon-menu3_watchlist':
        return <IconWatchlist />;
      case 'icon-menu3_chat':
        return <IconChat />;
      case 'icon-menu3_chartbit':
        return <IconChartbit />;
      case 'icon-menu3_orderbook':
        return <IconOrderbook />;
      case 'icon-menu3_eipo':
        return <IconEIpo />;
      case 'icon-menu3_academy':
        return <IconAcademy />;
      case 'icon-menu3_screener':
        return <IconScreener />;
      case 'icon-menu3_valuation':
        return <IconValuation />;
      case 'icon-menu3_financials':
        return <IconFinancials />;
      case 'icon-menu3_fundachart':
        return <IconFundachart />;
      case 'icon-menu3_seasonality':
        return <IconSeasonality />;
      case 'icon-menu3_sector':
        return <IconSector />;
      case 'icon-menu3_calendar':
        return <IconCalender />;
      case 'icon-menu3_earning':
        return <IconEarnings />;
      case 'icon-menu3_glossary':
        return <IconGlossary />;
      case 'icon-menu3_ebook':
        return <IconEBook />;
    }
  };

  return (
    <PopoverMobile componentTrigger={componentTrigger}>
      <PopoverNavbarContainer>
        {renderTradingPopup()}
        <Grid>
          {generateNavBar(data).map((item) => (
            <ReloadHandler
              href={item.href}
              label={item.label}
              isMobile
              data-cy={item['data-cy']}
            >
              <div
                style={{
                  color: item.matcher(router) ? color.primary : color.dimgray,
                }}
              >
                {renderIcon(item.logoMobile)}
              </div>
              <Text
                as="a"
                size="11px"
                align="center"
                color={item.matcher(router) ? color.primary : color.dimgray}
              >
                {item.label}
              </Text>
            </ReloadHandler>
          ))}
        </Grid>
      </PopoverNavbarContainer>
    </PopoverMobile>
  );
};

export default Mobile;
